import { useState, useCallback } from 'react';

export const useServiceSelection = (initialCatId = 0, initialSubcatId = 0, initialServiceId = 0) => {
    const [serviceState, setServiceState] = useState({
        serviceCategories: [],
        selectedCatId: initialCatId,
        selectedSubcatId: initialSubcatId,
        selectedServiceId: initialServiceId,
    });

    const [serviceChangeWarning, setServiceChangeWarning] = useState({
        shown: false,
        updatedField: "",
        newValue: 0
    });

    const updateCategory = useCallback((catId, force = false) => {
        if (!serviceState.selectedServiceId || force) {
            setServiceState(prev => ({ ...prev, selectedCatId: catId }));
            return true;
        } else {
            setServiceChangeWarning({
                shown: true,
                updatedField: "cat",
                newValue: catId
            });
            return false;
        }
    }, [serviceState.selectedServiceId]);

    const updateSubCategory = useCallback((subCatId, force = false) => {
        if (!serviceState.selectedServiceId || force) {
            setServiceState(prev => ({ ...prev, selectedSubcatId: subCatId }));
            return true;
        } else {
            setServiceChangeWarning({
                shown: true,
                updatedField: "sub",
                newValue: subCatId
            });
            return false;
        }
    }, [serviceState.selectedServiceId]);

    const updateService = useCallback((serviceId, force = false) => {
        if (!serviceState.selectedServiceId || force) {
            setServiceState(prev => ({ ...prev, selectedServiceId: serviceId }));
            return true;
        } else {
            setServiceChangeWarning({
                shown: true,
                updatedField: "service",
                newValue: serviceId
            });
            return false;
        }
    }, [serviceState.selectedServiceId]);

    const acceptServiceChange = useCallback((onReset) => {
        setServiceState(prev => ({
            ...prev,
            selectedServiceId: serviceChangeWarning.updatedField === "cat" ? 0 :
                (serviceChangeWarning.updatedField === "sub" ? 0 : serviceChangeWarning.newValue),
            selectedSubcatId: serviceChangeWarning.updatedField === "cat" ? 0 :
                (serviceChangeWarning.updatedField === "service" ? prev.selectedSubcatId : serviceChangeWarning.newValue),
            selectedCatId: serviceChangeWarning.updatedField === "sub" ? prev.selectedCatId :
                (serviceChangeWarning.updatedField === "service" ? prev.selectedCatId : serviceChangeWarning.newValue),
        }));
        
        setServiceChangeWarning({ shown: false, updatedField: "", newValue: 0 });
        
        if (onReset) {
            onReset();
        }
    }, [serviceChangeWarning]);

    const rejectServiceChange = useCallback(() => {
        setServiceChangeWarning({ shown: false, updatedField: "", newValue: 0 });
    }, []);

    const setServiceCategories = useCallback((categories) => {
        setServiceState(prev => ({ ...prev, serviceCategories: categories }));
    }, []);

    return {
        serviceState,
        serviceChangeWarning,
        updateCategory,
        updateSubCategory,
        updateService,
        acceptServiceChange,
        rejectServiceChange,
        setServiceCategories,
        setServiceState
    };
};
